import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {ActiviteAssechement} from '../../../models/activiteAssechement.model';
import {Etage} from '../../../models/etage.model';
import {merge} from 'lodash-es';
import {Piece} from '../../../models/piece.model';
import {User} from '../../../models/user.model';
import {DossierInterventionService} from '../../../services/dossier_intervention.service';
import {UserService as AuthUserService} from '../../../core/user/user.service';
import {formatDate} from '@angular/common';

@Component({
    selector: 'app-modal-activite-assechement',
    templateUrl: './modal-activite-assechement.component.html'
})
export class ModalActiviteAssechementComponent implements OnInit {
    @Input() activiteAssechement: ActiviteAssechement;
    @Input() activitesAssechements: Array<ActiviteAssechement> = []; //List of previous activiteAssechements
    @Input() pieces: Array<Piece> = [];
    @Input() etages: Array<Etage> = [];
    @Input() techniciens: Array<User> = [];
    @Input() materials: string[] = [];
    @Input() surfaces: string[] = [];

    error: boolean = false;
    activiteAssechementForm: FormGroup;


    constructor(
        private dossierInterventionService: DossierInterventionService,
        private authUserService: AuthUserService,
        public dialogRef: MatDialogRef<ModalActiviteAssechementComponent>,
    ) {
    }

    ngOnInit(): void {
        this.activiteAssechementForm = new FormGroup({
            id: new FormControl(this.activiteAssechement.id),
            etage_id: new FormControl(this.activiteAssechement.dossier_intervention_activite_assechement.etage_id, [Validators.required]),
            piece_id: new FormControl(this.activiteAssechement.dossier_intervention_activite_assechement.piece_id, [Validators.required]),
            surface: new FormControl(this.activiteAssechement.dossier_intervention_activite_assechement.surface, [Validators.required]),
            material: new FormControl(this.activiteAssechement.dossier_intervention_activite_assechement.material, [Validators.required]),
            standard: new FormControl(this.activiteAssechement.dossier_intervention_activite_assechement.standard ?? '', [Validators.required]),
            visit_date: new FormControl(formatDate(this.activiteAssechement.visit_date ?? new Date(), 'yyyy-MM-dd', 'en'), [Validators.required]),
            humidity: new FormControl(this.activiteAssechement.humidity, [Validators.required]),
            technicien_id: new FormControl(this.activiteAssechement.technicien_id ?? this.authUserService.getCurrentUser().id, [Validators.required]),
        });

        this.activiteAssechementForm.valueChanges.subscribe(values=>this.onFormChange(values));
    }
    onFormChange(values): void {
        this.fetchExistingStandard(values);
    }

    fetchExistingStandard(values): void {
        if (this.activiteAssechementForm.value) {
            if (
                this.activiteAssechementForm.value.piece_id &&
                this.activiteAssechementForm.value.etage_id &&
                this.activiteAssechementForm.value.surface &&
                this.activiteAssechementForm.value.material &&
                (
                    this.activiteAssechementForm.value.piece_id !== this.activiteAssechement.dossier_intervention_activite_assechement.piece_id ||
                    this.activiteAssechementForm.value.etage_id !== this.activiteAssechement.dossier_intervention_activite_assechement.etage_id ||
                    this.activiteAssechementForm.value.surface !== this.activiteAssechement.dossier_intervention_activite_assechement.surface ||
                    this.activiteAssechementForm.value.material !== this.activiteAssechement.dossier_intervention_activite_assechement.material
                )
            ) {
                const existingReport = this.activitesAssechements.find(report => (
                        report.dossier_intervention_activite_assechement.piece_id === this.activiteAssechementForm.value.piece_id &&
                        report.dossier_intervention_activite_assechement.etage_id === this.activiteAssechementForm.value.etage_id &&
                        report.dossier_intervention_activite_assechement.surface === this.activiteAssechementForm.value.surface &&
                        report.dossier_intervention_activite_assechement.material === this.activiteAssechementForm.value.material
                    ));
                if (
                    existingReport &&
                    existingReport.dossier_intervention_activite_assechement.standard !== values.standard
                ) {
                    this.activiteAssechementForm.controls['standard'].setValue(existingReport.dossier_intervention_activite_assechement.standard);
                }
            }
        }
    }

    onFormSubmit(): void {
        this.error = false;
        this.activiteAssechementForm.markAllAsTouched();

        if (this.activiteAssechementForm.valid) {
            const activiteAssechement = this.activiteAssechement;
            const values = this.activiteAssechementForm.value;

            activiteAssechement.visit_date = values.visit_date;
            activiteAssechement.technicien_id = values.technicien_id;
            activiteAssechement.humidity = values.humidity;

            activiteAssechement.dossier_intervention_activite_assechement.etage_id = values.etage_id;
            activiteAssechement.dossier_intervention_activite_assechement.piece_id = values.piece_id;
            activiteAssechement.dossier_intervention_activite_assechement.material = values.material;
            activiteAssechement.dossier_intervention_activite_assechement.standard = values.standard;
            activiteAssechement.dossier_intervention_activite_assechement.surface = values.surface;

            this.dossierInterventionService.storeOrUpdateActiviteAssechementsForDossierIntervention(
                activiteAssechement.dossier_intervention_activite_assechement.dossier_intervention_id,
                activiteAssechement
            ).subscribe(
                (response) => {
                    this.dialogRef.close(response);
                }, (error) => {
                    this.error = true;
                }
            );

        }
    }
}
